import { getAffiliateHref } from '../lib/affiliateLinks';

export const OURDREAM_AFFILIATE_LINK = getAffiliateHref('ourdream-ai');

export function getReviewLinkDestination(slug: string): string {
  return `/reviews/${slug}`;
}
